import graphql__2c41ed1b9be91880b025 from "./__generated__/DraftInvoiceViewUpdatePurchaseOrderReferenceMutation.graphql.ts";
import graphql__8975873137ebc53855c1 from "./__generated__/DraftInvoiceViewUpdateCustomerOrderNotesMutation.graphql.ts";
import graphql__e4fce58382cef40ca354 from "./__generated__/DraftInvoiceViewAddInvoiceAttachmentMutation.graphql.ts";
import graphql__5cbb0d810ccbb7acbd17 from "./__generated__/DraftInvoiceViewDownloadInvoiceAttachmentMutation.graphql.ts";
import graphql__9d0b1f99d392d01a3872 from "./__generated__/DraftInvoiceViewRemoveInvoiceAttachmentMutation.graphql.ts";
import graphql__ccefad5285b0159f2a3a from "./__generated__/DraftInvoiceViewDownloadPdfMutation.graphql.ts";
import graphql__924342525ae62a868344 from "./__generated__/DraftInvoiceViewUpdateTimeOfPerformanceMutation.graphql.ts";
import graphql__96774617f420977fa2af from "./__generated__/DraftInvoiceView_invoice.graphql.ts";import * as React from "react";
import {useState} from "react";
import {graphql} from "react-relay";
import Panel from "./presentational/Panel";
import BreadcrumbNavigation from "./navigation/BreadcrumbNavigation";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import InvoiceHeader from "./InvoiceHeader";
import {connect, ConnectedProps} from "react-redux";
import {hideModal, showModal} from "../store/actions";
import InvoiceLineItemsTable from "./InvoiceLineItemsTable";
import {countries} from "../Countries";
import {languages} from "../Languages";
import DataListItem from "./presentational/DataListItem";
import {FormattedDate, FormattedDateTimeRange, useIntl} from "react-intl";
import {formatISO, parseISO} from "../helper/date";
import EditableDataListField, {FieldDataType,} from "./form/EditableDataListField";
import EditableDataListItem from "./form/EditableDataListItem";
import {AutomaticTime} from "./form/DatePickerField";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload, faPaperclip, faTrashCan,} from "@fortawesome/pro-regular-svg-icons";
import Dropzone from "react-dropzone";
import {faUpload} from "@fortawesome/pro-light-svg-icons";
import ActionButton from "./presentational/button/ActionButton";
import {Navigate, useOutletContext} from "react-router";
import {faFilePdf} from "@fortawesome/pro-solid-svg-icons";
import FinalizeInvoiceDialog from "./dialog/FinalizeInvoiceDialog";
import {useErrorContext} from "../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../helper/commitMutationWithErrorHandling";

type DraftInvoiceViewParams = {};

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal,
});

type DraftInvoiceViewProps = DraftInvoiceViewParams &
    ConnectedProps<typeof connector>;

const DraftInvoiceView: React.FC<DraftInvoiceViewProps> = (props) => {
    const intl = useIntl();
    const {dispatchShowModal, dispatchHideModal} = props;
    const relayEnvironment = useRelayEnvironment();
    const outletContext: any = useOutletContext();
    const {queryRef} = outletContext;

    const [isDownloadingPdf, setIsDownloadingPdf] = useState(false);
    const {addError} = useErrorContext();

    const handleUpdatePurchaseOrderReference = (
        input,
        setEditingActive,
        relayEnvironment
    ) => {
        commitMutationWithErrorHandling(relayEnvironment, {
                mutation: graphql__2c41ed1b9be91880b025,
                variables: {
                    input: input,
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    setEditingActive(false);
                },
                onError: (error) => {
                    console.error(error);
                    setEditingActive(false);
                }
            },
            addError)
    };

    const handleUpdateCustomerOrderNotes = (
        input,
        setEditingActive,
        relayEnvironment
    ) => {
        commitMutationWithErrorHandling(relayEnvironment, {
            mutation: graphql__8975873137ebc53855c1,
            variables: {
                input: input,
            },
            onCompleted: (response, errors) => {
                if (errors && errors.length > 0) {
                    console.error(errors);
                }
                setEditingActive(false);
            },
            onError: (error) => {
                console.error(error);
                setEditingActive(false);
            },
        }, addError);
    };

    const handleAttachmentUploads = (
        acceptedFiles: File[],
        invoiceIdentifier: string,
        relayEnvironment
    ) => {
        acceptedFiles.forEach((file, index) => {
            const fileReader = new FileReader();
            fileReader.onload = () => {
                if (fileReader.readyState === 2) {
                    const input = {
                        id: invoiceIdentifier,
                        upload: {
                            filename: file.name,
                            data: fileReader.result,
                            lastModifiedAt: formatISO(
                                new Date(file.lastModified)
                            ),
                        },
                    };
                    commitMutationWithErrorHandling(relayEnvironment, {
                        mutation: graphql__e4fce58382cef40ca354,
                        variables: {
                            input: input,
                        },
                        onCompleted: (response, errors) => {
                            if (errors && errors.length > 0) {
                                console.error(errors);
                            }
                        },
                        onError: (error) => {
                            console.error(error);
                        },
                    }, addError);
                }
            };
            fileReader.readAsDataURL(file);
        });
    };

    const handleDownloadAttachment = (
        invoiceIdentifier: string,
        sha1: string,
        relayEnvironment
    ) => {
        commitMutationWithErrorHandling(relayEnvironment, {
            mutation: graphql__5cbb0d810ccbb7acbd17,
            variables: {
                input: {
                    id: invoiceIdentifier,
                    sha1: sha1,
                },
            },
            onCompleted: (response, errors) => {
                if (errors && errors.length > 0) {
                    console.error(errors);
                }
                if (response.downloadInvoiceAttachment?.uri) {
                    window.location.href =
                        response.downloadInvoiceAttachment?.uri;
                }
            },
            onError: (error) => {
                console.error(error);
            },
        }, addError);
    };

    const handleRemoveAttachment = (
        invoiceIdentifier: string,
        sha1: string,
        relayEnvironment
    ) => {
        commitMutationWithErrorHandling(relayEnvironment, {
            mutation: graphql__9d0b1f99d392d01a3872,
            variables: {
                input: {
                    id: invoiceIdentifier,
                    sha1: sha1,
                },
            },
            onCompleted: (response, errors) => {
                if (errors && errors.length > 0) {
                    console.error(errors);
                }
            },
            onError: (error) => {
                console.error(error);
            },
        }, addError);
    };

    const handleDownloadPdf = (
        invoiceIdentifier: string,
        setIsDownloadingPdf,
        relayEnvironment
    ) => {
        setIsDownloadingPdf(true);
        commitMutationWithErrorHandling(relayEnvironment, {
            mutation: graphql__ccefad5285b0159f2a3a,
            variables: {
                id: invoiceIdentifier,
            },
            onCompleted: (response, errors) => {
                if (errors && errors.length > 0) {
                    console.error(errors);
                }
                setIsDownloadingPdf(false);
                if (response.downloadInvoicePdf?.uri) {
                    window.location.href = response.downloadInvoicePdf?.uri;
                }
            },
            onError: (error) => {
                setIsDownloadingPdf(false);
                console.error(error);
            },
        }, addError);
    };

    const handleUpdateTimeOfPerformance = (
        input,
        setEditingActive,
        relayEnvironment
    ) => {
        commitMutationWithErrorHandling(relayEnvironment, {
                mutation: graphql__924342525ae62a868344,
                variables: {
                    input: input,
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        addError({
                            message: "errors.failedToUpdateTimeOfPerformance",
                            type: 'relay',
                            details: errors
                        });
                    } else {
                        setEditingActive(false);
                    }
                },
                onError: (error) => {
                    setEditingActive(false);
                    addError({
                        message: "errors.failedToUpdateTimeOfPerformance",
                        type: 'relay',
                        details: error
                    });
                },
            },
            addError,
            {
                suppressGlobalErrorHandling: true
            });
    };

    const invoice = useFragment(
        graphql__96774617f420977fa2af,
        queryRef
    );

    if (invoice == null) {
        return <></>;
    }

    const breadcrumbNavigationItems = [
        {label: intl.formatMessage({id: 'navigation.invoices'}), to: "/invoices"},
        {label: invoice.id, to: "/invoices/" + invoice.id + "/edit"},
    ];

    if (invoice.state !== "DRAFT") {
        return <Navigate to={"/invoices/" + invoice.id}/>;
    }

    const showFinalizeInvoiceDialog = () => {
        dispatchShowModal({
            body: (
                <FinalizeInvoiceDialog
                    handleCloseDialog={dispatchHideModal}
                    queryRef={invoice}
                />
            ),
        });
    };

    return (
        <article>
            <BreadcrumbNavigation items={breadcrumbNavigationItems}/>
            <InvoiceHeader invoice={invoice}/>
            <div className="mx-auto lg:px-8 grid grid-cols-1 gap-x-4 gap-y-8 py-8">
                <Panel
                    buttons={
                        <>
                            <ActionButton
                                icon={faFilePdf}
                                iconSize={"lg"}
                                isSubmitting={isDownloadingPdf}
                                title={intl.formatMessage({id: 'button.downloadPdf'})}
                                onClick={() => {
                                    handleDownloadPdf(
                                        invoice.id,
                                        setIsDownloadingPdf,
                                        relayEnvironment
                                    );
                                }}
                            />
                            <ActionButton
                                label={intl.formatMessage({id: 'button.finalize'})}
                                onClick={() => {
                                    showFinalizeInvoiceDialog();
                                }}
                            />
                        </>
                    }
                >
                    <div className="flex mb-4 justify-between">
                        <div className="w-96 h-48 bg-gray-50 p-4 border border-gray-200">
                            <span className="font-bold">
                                {invoice.address.businessName}
                            </span>
                            <br/>
                            {invoice.address.addressLine1}
                            <br/>
                            {invoice.address.addressLine2 && (
                                <>
                                    {invoice.address.addressLine2}
                                    <br/>
                                </>
                            )}
                            <br/>
                            {invoice.address.postalCode} {invoice.address.city}
                            <br/>
                            {countries[invoice.address.country]}
                        </div>
                        <div className="px-4">
                            <dl className="py-2">
                                <DataListItem
                                    label={intl.formatMessage({id: 'invoice.field.documentLanguage'})}
                                    condensed={true}
                                >
                                    {languages[invoice.language]}
                                </DataListItem>
                            </dl>
                            <dl className="py-2">
                                <DataListItem
                                    label={intl.formatMessage({id: 'invoice.field.invoiceNumber'})}
                                    condensed={true}
                                >
                                    {invoice.invoiceNumber ?? "-"}
                                </DataListItem>
                                <DataListItem
                                    label={intl.formatMessage({id: 'invoice.field.invoiceDate'})}
                                    condensed={true}
                                >
                                    <FormattedDate
                                        value={invoice.invoiceDate}
                                    />
                                </DataListItem>
                                {invoice.relatedInvoice !== null && (
                                    <DataListItem
                                        label={intl.formatMessage({id: 'invoice.field.relatedInvoice'})}
                                        condensed={true}
                                    >
                                        {invoice.relatedInvoice.invoiceNumber ??
                                            "-"}
                                    </DataListItem>
                                )}
                                <DataListItem
                                    label={intl.formatMessage({id: 'customer.field.customerNumber'})}
                                    condensed={true}
                                >
                                    {invoice.customerAccount.customerNumber}
                                </DataListItem>
                                <DataListItem
                                    label={intl.formatMessage({id: 'customer.field.vatId'})}
                                    condensed={true}
                                >
                                    {invoice.customerAccount.vatId ?? "-"}
                                </DataListItem>
                            </dl>
                            <dl className="py-2">
                                <EditableDataListItem
                                    label={intl.formatMessage({id: 'invoice.field.periodOfPerformance'})}
                                    fields={
                                        <>
                                            <EditableDataListField
                                                fieldDataType={
                                                    FieldDataType.dateSelector
                                                }
                                                name="timeOfPerformanceStart"
                                                className="flex pb-2"
                                                automaticTime={AutomaticTime.STARTOFDAY}
                                            />
                                            <EditableDataListField
                                                fieldDataType={
                                                    FieldDataType.dateSelector
                                                }
                                                name="timeOfPerformanceEnd"
                                                automaticTime={AutomaticTime.ENDOFDAY}
                                                className="flex pt-2"
                                            />
                                        </>
                                    }
                                    initialValues={{
                                        id: invoice.id,
                                        timeOfPerformanceStart:
                                        invoice.timeOfPerformanceStart,
                                        timeOfPerformanceEnd:
                                        invoice.timeOfPerformanceEnd,
                                    }}
                                    handleSubmission={(
                                        values,
                                        setEditingActive
                                    ) =>
                                        handleUpdateTimeOfPerformance(
                                            values,
                                            setEditingActive,
                                            relayEnvironment
                                        )
                                    }
                                >
                                    <FormattedDateTimeRange
                                        from={parseISO(
                                            invoice.timeOfPerformanceStart
                                        )}
                                        to={parseISO(
                                            invoice.timeOfPerformanceEnd
                                        )}
                                    />
                                </EditableDataListItem>
                                <EditableDataListItem
                                    label={intl.formatMessage({id: 'invoice.field.purchaseOrderReference'})}
                                    fields={
                                        <EditableDataListField
                                            fieldDataType={FieldDataType.text}
                                            name="purchaseOrderReference"
                                        />
                                    }
                                    initialValues={{
                                        id: invoice.id,
                                        purchaseOrderReference:
                                        invoice.purchaseOrderReference,
                                    }}
                                    handleSubmission={(
                                        values,
                                        setEditingActive
                                    ) =>
                                        handleUpdatePurchaseOrderReference(
                                            values,
                                            setEditingActive,
                                            relayEnvironment
                                        )
                                    }
                                >
                                    {invoice.purchaseOrderReference}
                                </EditableDataListItem>
                                <EditableDataListItem
                                    label={intl.formatMessage({id: 'invoice.field.customerOrderNotes'})}
                                    fields={
                                        <EditableDataListField
                                            fieldDataType={FieldDataType.text}
                                            name="customerOrderNotes"
                                        />
                                    }
                                    initialValues={{
                                        id: invoice.id,
                                        customerOrderNotes:
                                        invoice.customerOrderNotes,
                                    }}
                                    handleSubmission={(
                                        values,
                                        setEditingActive
                                    ) =>
                                        handleUpdateCustomerOrderNotes(
                                            values,
                                            setEditingActive,
                                            relayEnvironment
                                        )
                                    }
                                >
                                    {invoice.customerOrderNotes}
                                </EditableDataListItem>
                            </dl>
                        </div>
                    </div>
                </Panel>
                <Panel>
                    <InvoiceLineItemsTable queryRef={invoice}/>
                </Panel>

                <Panel headline={intl.formatMessage({id: 'invoice.section.notes'})}>
                    {invoice.paymentNote && (
                        <p className="mt-1 text-sm text-gray-900">
                            {invoice.paymentNote}
                        </p>
                    )}
                    <dl className="py-2">
                        {invoice.taxTypeNote && (
                            <p className="mt-1 text-sm text-gray-900">
                                {invoice.taxTypeNote}
                            </p>
                        )}
                    </dl>
                </Panel>

                <Panel headline={intl.formatMessage({id: 'invoice.section.attachments'})}>
                    <ul className="divide-y divide-gray-200 rounded-md border border-gray-200">
                        {invoice.attachments.map((attachment) => {
                            let isSubmitting = false;
                            return (
                                <li
                                    key={attachment.sha1}
                                    className="flex items-center justify-between py-3 pl-3 pr-4 text-sm group"
                                >
                                    <div className="flex w-0 flex-1 items-center">
                                        <FontAwesomeIcon
                                            className="h-5 w-5 shrink-0 text-gray-400"
                                            icon={faPaperclip}
                                        />
                                        <span className="ml-2 w-0 flex-1 truncate">
                                            {attachment.filename}
                                        </span>
                                    </div>
                                    <div className="ml-4 shrink-0">
                                        <button
                                            type="button"
                                            tabIndex={-1}
                                            onClick={(event) =>
                                                handleDownloadAttachment(
                                                    invoice.id,
                                                    attachment.sha1,
                                                    relayEnvironment
                                                )
                                            }
                                            className="py-3 px-4 text-sm font-medium text-gray-700 invisible group-hover:visible"
                                        >
                                            <FontAwesomeIcon
                                                icon={faDownload}
                                            />
                                        </button>
                                        <button
                                            type="button"
                                            tabIndex={-1}
                                            disabled={isSubmitting}
                                            onClick={(event) =>
                                                handleRemoveAttachment(
                                                    invoice.id,
                                                    attachment.sha1,
                                                    relayEnvironment
                                                )
                                            }
                                            className="py-3 px-4 text-sm font-medium text-gray-700 invisible group-hover:visible"
                                        >
                                            <FontAwesomeIcon
                                                icon={faTrashCan}
                                            />
                                        </button>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                    <Dropzone
                        accept={{
                            "application/pdf": [".pdf"],
                        }}
                        onDrop={(acceptedFiles) =>
                            handleAttachmentUploads(
                                acceptedFiles,
                                invoice.id,
                                relayEnvironment
                            )
                        }
                    >
                        {({getRootProps, getInputProps}) => (
                            <div
                                className="flex w-full justify-center rounded-md border-2 border-dashed border-gray-300 mt-8 px-6 pt-5 pb-6"
                                {...getRootProps()}
                            >
                                <div className="space-y-1 text-center">
                                    <FontAwesomeIcon
                                        className="mx-auto h-12 w-12 text-gray-400"
                                        icon={faUpload}
                                    />
                                    <div className="flex text-sm text-gray-600">
                                        <label
                                            htmlFor="file-upload"
                                            className="relative cursor-pointer rounded-md bg-white font-medium text-grey-600 focus-within:outline-hidden focus-within:ring-2 focus-within:ring-red-500 focus-within:ring-offset-2 hover:text-grey-500"
                                        >
                                            <span>{intl.formatMessage({id: 'invoice.attachment.upload'})}</span>
                                            <input {...getInputProps()} />
                                        </label>
                                        <p className="pl-1">{intl.formatMessage({id: 'invoice.attachment.dragAndDrop'})}</p>
                                    </div>
                                    <p className="text-xs text-gray-500">
                                        {intl.formatMessage({id: 'invoice.attachment.sizeLimit'})}
                                    </p>
                                </div>
                            </div>
                        )}
                    </Dropzone>
                </Panel>
            </div>
        </article>
    );
};

export default connector(DraftInvoiceView);
